module.exports = __webpack_public_path__ + "img/logo.f9659c12.png";